import styled from '@emotion/styled';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  text-align: left;

  textarea {
    max-height: 150px;
  }
`;

export { Form };
